"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const surveyHelper = __importStar(require("evolution-common/lib/utils/helpers"));
const react_i18next_1 = require("react-i18next");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const InputButtonOption = (props) => {
    if (props.choice.hidden === true ||
        !surveyHelper.parseBoolean(props.choice.conditional, props.interview, props.path, props.user)) {
        return null;
    }
    return (react_1.default.createElement("div", { key: `${props.id}__key`, className: 'survey-question__input-button-input-container' },
        react_1.default.createElement("button", { type: "button", className: `survey-section__button button ${props.choice.color || 'green'} ${props.choice.size || 'large'}`, onClick: (e) => props.onButtonClick(e, props.choice.value), id: props.id },
            props.choice.icon && react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: props.choice.icon, className: "faIconLeft" }),
            surveyHelper.translateString(props.choice.label, props.i18n, props.interview, props.path, props.user))));
};
const InputButtonOptionT = (0, react_i18next_1.withTranslation)()(InputButtonOption);
/** Display a list of choices as buttons */
const InputButton = (props) => {
    const widgetChoices = props.widgetConfig.choices;
    const choices = typeof widgetChoices === 'function' ? widgetChoices(props.interview, props.path, props.user) : widgetChoices;
    // FIXME: original code had an action parameter, that was part of the choice object. It isn't used anywhere though and the saveCallback and valueChange should be enough to cover the case. If not, revisit this.
    const onButtonClick = (e, value) => {
        e.preventDefault();
        props.onValueChange({ target: { value } });
    };
    const choiceInputs = choices.map((choice, index) => (react_1.default.createElement(InputButtonOptionT, { key: `${props.id}_btn_${index}`, id: `${props.id}__input-button__${choice.value}`, choice: choice, path: props.path, interview: props.interview, user: props.user, onButtonClick: onButtonClick })));
    return (react_1.default.createElement("div", { className: `survey-question__input-button-group-container${props.widgetConfig.sameLine === false ? ' no-wrap' : ''}${props.widgetConfig.align === 'center' ? ' align-center' : ''}` }, choiceInputs));
};
exports.default = (0, react_i18next_1.withTranslation)()(InputButton);
//# sourceMappingURL=InputButton.js.map